/**
 * Identity document type values
 */
export enum IdentityDocumentTypeEnum {
	ID_CARD = 'id_card',
	PASSPORT = 'passport',
	RESIDENCE_PERMIT = 'residence_permit',
	OTHER = 'other',
}
